import { ignoreEnqueuedItem, forceGetFileQueue } from 'actions/fileQueueActions';
import { useAppDispatch } from 'hooks';
import React from 'react';
import FileIgnorePopup from './FileIgnorePopup';
type FileIgnoreComponentType = {
  selectedFile: String | Element;
  setToIgnoreItem: (arg0: String) => void;
};

const FileIgnoreComponent = ({ selectedFile, setToIgnoreItem }: FileIgnoreComponentType) => {
  const dispatch = useAppDispatch();

  const ignoreFile = () => {
    dispatch(ignoreEnqueuedItem(selectedFile));
    dispatch(forceGetFileQueue());
  };

  return (
    <React.Fragment>
      <FileIgnorePopup onConfirm={ignoreFile}  setToIgnoreItem={setToIgnoreItem} />
    </React.Fragment>
  );
};

export default FileIgnoreComponent;
